import React from 'react'
import { connect } from 'react-redux'
import { Grid, Item, Select, Icon, Dimmer, Loader, Segment } from 'semantic-ui-react'
import { BRIGHT_ORANGE, BLUE } from '../../constants/colors'
import { displayCurrency } from '../../utils/utils'

const RefreshButton = ({onClick}) => {
  const refreshButtonStyle = {
    border: `2px solid ${BRIGHT_ORANGE}`,
    padding: '8px 16px',
    borderRadius: '20px',
    cursor: 'pointer'
  }
  const refreshLinkStyle = { color: BRIGHT_ORANGE, textDecoration: 'underline' }

  return (
    <div style={refreshButtonStyle} onClick={onClick}>
      <Icon name='refresh' style={{color: BRIGHT_ORANGE}} />
      <strong>
        {`New Content `}
        <span style={refreshLinkStyle}>Refresh</span>
      </strong>
    </div>
  )
}

class Header extends React.Component {
  paginationText() {
    const { currentPage, totalRecords, recordsPerPage } = this.props

    const firstRecordNumber = (currentPage - 1) * recordsPerPage + 1
    const lastRecordNumber = Math.min(currentPage * recordsPerPage, totalRecords)

    return (
      <small>
        <strong>
          {`Displaying ${firstRecordNumber} - ${lastRecordNumber} of ${totalRecords}`}
        </strong>
      </small>
    )
  }

  updateFilterStore = (data) => {
    this.props.dispatch({
      type: 'SHOP_ORDER_FILTERS_UPDATE',
      payload: data
    })
  }

  onRefresh = () => {
    this.props.dispatch({ type: 'SHOP_ORDERS_FILTER_SAGA' })
  }

  fetchTotals = () => {
    this.props.dispatch({ type: 'SHOP_ORDERS_TOTALS_LOAD_SAGA' })
  }

  fetchOrderTotalsButton = () => {
    const { isLoading } = this.props

    return(
      <div style={{padding: '8px 0'}}>
        {isLoading &&
          <Segment style={{width: '125px'}}>
            <Dimmer inverted active>
              <Loader indeterminate size='tiny'></Loader>
            </Dimmer>
          </Segment>
        }
        {!isLoading &&
          <div onClick={this.fetchTotals}>
            <span style={{cursor: 'pointer'}}>
              <Icon name='refresh' style={{color: BLUE}} />
              <small><strong>Fetch Order Totals</strong></small>
            </span>
          </div>
        }
      </div>
    )
  }

  orderTotals = () => {
    const { needsFetch, total, pageTotal, alreadyPaid, pageAlreadyPaid } = this.props
    if (needsFetch)
      return this.fetchOrderTotalsButton()
    else {
      return (
        <React.Fragment>
          <small style={{display: 'block'}}>
            All Orders in Filter:
            {` Total: ${displayCurrency(total)}, Already Paid: ${displayCurrency(alreadyPaid)}`}
          </small>
          <small style={{display: 'block'}}>
            Orders on this Page:
            {` Total: ${displayCurrency(pageTotal)}, Already Paid: ${displayCurrency(pageAlreadyPaid)}`}
          </small>
        </React.Fragment>
      )
    }
  }

  render() {
    const { totalRecords, needsRefresh, exclude_tbc } = this.props
    const refreshContainerStyle = {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '0.9rem'
    }

    return (
      <React.Fragment>
        <Grid columns='equal'>
          <Grid.Column>
            <Item>
              <small>
                <Select
                  options={[
                    { text: 'Exclude TBC', value: true, key: 'aff-filter-exclude-tbc' },
                    { text: 'All Orders', value: false, key: 'aff-filter-none' }
                  ]}
                  onChange={(e, selection) => {
                    e.preventDefault()
                    this.updateFilterStore({ exclude_tbc: selection.value })
                  }}
                  value={exclude_tbc}
                  style={{marginRight: 0, marginBottom: '10px', maxWidth: '200px'}}
                />
              </small>
            </Item>
            {totalRecords > 0 && this.paginationText()}
          </Grid.Column>
          <Grid.Column style={refreshContainerStyle}>
            {needsRefresh && <RefreshButton onClick={this.onRefresh} />}
          </Grid.Column>
          {/* Extra column for spacing */}
          <Grid.Column>
          </Grid.Column>
        </Grid>
        {this.orderTotals()}
      </React.Fragment>
    )
  }
} // Header

const mapStateToProps = (state) => {
  const filters = state.shopOrderFilters.currentFilters || {}
  const shopOrders = state.shopOrders || {}
  const totals = shopOrders.totals || {}

  return {
    isLoading: state.application.loadingShopOrderTotals,
    isLoadingError: state.application.isLoadingError,
    total: totals.total,
    alreadyPaid: totals.already_paid,
    pageTotal: totals.page_total,
    pageAlreadyPaid: totals.page_already_paid,
    needsFetch: shopOrders.needsTotalsFetch,
    currentFilters: filters,
    exclude_tbc: filters.exclude_tbc,
    totalRecords: shopOrders.total_records,
    recordsPerPage: shopOrders.records_per_page,
    currentPage: shopOrders.current_page,
    needsRefresh: shopOrders.notifications.length > 0
  }
}

export default connect(mapStateToProps)(Header)
